/**
 * RequireSignedOut — the guard for /login, the local sign-in form's own address.
 *
 * /login works on EVERY host (user order 2026-10-23), as in legacy, whose
 * router has a /login route everywhere and sends a visitor who already has a
 * session from it to Manage Portfolio (router/index.js:36, :137). The landing
 * URL is unchanged: RequireAuth still shows the default sign-in screen there.
 *
 *  - signed out: the form (`children`);
 *  - 'authenticating': the form STAYS, for the reason RequireAuth gives — the
 *    form sets that status itself on submit, and unmounting it then would lose
 *    the error a wrong password has to show;
 *  - signed in (a cookie session, or the form just succeeded): `to`, the
 *    product's default section. `replace`, so Back does not return to the form.
 */
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectAuthStatus, selectIsAuthenticated } from '@security/auth/authSlice';

export function RequireSignedOut({ children, to }) {
  const status = useSelector(selectAuthStatus);
  const isAuthed = useSelector(selectIsAuthenticated);

  // Not settled yet (bootstrapAuth runs before the first render; a safety net).
  // Nothing is shown, never a "Loading…" page.
  if (status === 'idle') return null;

  if (isAuthed) return <Navigate to={to} replace />;
  return children;
}
